import * as momentPropTypes from 'react-moment-proptypes';
import React from 'react';
import DateDisplay from './DateDisplay';
import Icons from '../../../../core/modules/common/components/Icons';

const PeriodDisplay = (props) => {
  const {
    startDate,
    endDate,
  } = props;
  const dateFormat = 'DD/MM/YYYY';
  const isDatesEqual =
    !!(startDate && endDate && (startDate.format(dateFormat) === endDate.format(dateFormat)));

  return (
    <div className="period-selection__period-display">
      <div className="period-selection__icon">
        <Icons.Custom name="calendar" />
      </div>
      {isDatesEqual === false &&
        <div>
          <DateDisplay date={startDate} title="FROM" />
          <div className="period-selection__icon arrow">
            <Icons.Custom name="arrow-right" />
          </div>
          <DateDisplay date={endDate} title="TO" />
        </div>
      }
      {isDatesEqual &&
        <div>
          <DateDisplay date={startDate} title="SELECTED DATE" />
        </div>
      }
    </div>
  );
};
export default PeriodDisplay;

PeriodDisplay.propTypes = {
  startDate: momentPropTypes.momentObj,
  endDate: momentPropTypes.momentObj,
};
